import { render } from "./NewHospital.vue?vue&type=template&id=3637c664"
import script from "./NewHospital.vue?vue&type=script&lang=js"
export * from "./NewHospital.vue?vue&type=script&lang=js"

import "./NewHospital.vue?vue&type=style&index=0&id=3637c664&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/hospitals/NewHospital.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3637c664"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3637c664', __exports__)) {
    console.log('reload')
    api.reload('3637c664', __exports__)
  }
  
  module.hot.accept("./NewHospital.vue?vue&type=template&id=3637c664", () => {
    console.log('re-render')
    api.rerender('3637c664', render)
  })

}


export default __exports__